module.exports = __webpack_public_path__ + "img/samsung-galaxy-s3.6fd70671.png";